import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ minimized }) => minimized && 'line-height: 1.3;'}

  img {
    display: block;
    max-width: ${({ minimized }) => (minimized ? '30px' : '40px')};
    height: auto;
    border-radius: 6px;
    margin-right: 2rem;
  }
  ${({ minimized }) =>
    !minimized &&
    `
  @media (max-width: 800px) {
    flex-direction: column;
    img {
      max-width: 200px;
      margin: 2rem 0 2rem 0;
      margin-bottom: 2rem;
    }
  }`}
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Author = styled(NavLink)`
  font-size: 14px;
  align-self: center;
  text-align: center;
  text-decoration: none;
  color: var(--text);
  transition: all 0.2s;
  &:hover {
    color: var(--accent);
  }
`;
